(function(){
  if (window.__sjwFlow) return; window.__sjwFlow = true;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches) return;

  var DUR = 420;            /* must match the CSS height transition */
  var token = 0, lastOpenH = 0, settle = null;

  function panel(){ return document.querySelector('.sjwpp-panel'); }
  function rows(p){ return p.querySelectorAll('.sjwpp-row'); }
  function isGold(tab){ return /gold/i.test(tab.textContent || ''); }

  /* number the chips diagonally: top-left (0) -> bottom-right (last) */
  function setDiag(p){
    var rs = rows(p);
    for (var i=0;i<rs.length;i++){
      var ks = rs[i].querySelectorAll('.sjwpp-k');
      for (var j=0;j<ks.length;j++){ ks[j].style.setProperty('--sjwd', i + j); }
    }
  }

  function openFlow(){
    var p = panel(); if (!p) return;
    var t = ++token; clearTimeout(settle);
    p.classList.remove('sjwflow-closing');

    /* already open -> just normalise, no replay */
    if (rows(p).length){ p.style.height = 'auto'; p.classList.remove('sjwflow-opening'); return; }

    var start = p.offsetHeight;          /* frozen on pointerdown (collapsed) */
    p.style.height = start + 'px';
    requestAnimationFrame(function go(){
      if (t !== token) return;
      var pp = panel(); if (!pp) return;
      if (!rows(pp).length){ requestAnimationFrame(go); return; }   /* wait for the section to build rows */
      setDiag(pp);
      pp.classList.add('sjwflow-opening');
      var prev = pp.style.height;        /* FLIP measure of the natural height */
      pp.style.height = 'auto';
      var target = pp.offsetHeight;
      pp.style.height = prev;
      void pp.offsetWidth;               /* commit the start before animating */
      pp.style.height = target + 'px';   /* glide open -> Diamond Weight glides with it */
      lastOpenH = target;
      settle = setTimeout(function(){
        if (t !== token) return;
        pp.style.height = 'auto';         /* stay responsive once settled */
        pp.classList.remove('sjwflow-opening');
      }, DUR + 160);
    });
  }

  function closeFlow(){
    var p = panel(); if (!p) return;
    var t = ++token; clearTimeout(settle);

    /* nothing to collapse (Silver -> Platinum etc.) -> keep it shut, no flash */
    if (!rows(p).length){ p.style.height = '0px'; p.classList.remove('sjwflow-opening','sjwflow-closing'); return; }

    var h = p.offsetHeight || lastOpenH;
    setDiag(p);
    p.classList.add('sjwflow-closing');
    p.classList.remove('sjwflow-opening');
    p.style.height = h + 'px';
    void p.offsetWidth;
    p.style.height = '0px';              /* glide shut -> layout below glides up */
    settle = setTimeout(function(){
      if (t !== token) return;
      var pp = panel(); if (pp) pp.classList.remove('sjwflow-closing');
    }, DUR + 160);
  }

  /* Freeze the panel to an explicit pixel height the instant a pill is pressed,
     BEFORE the click handler runs, so the section's untransitioned row add/remove
     can never snap the layout. */
  document.addEventListener('pointerdown', function(e){
    var tab = e.target.closest ? e.target.closest('.sjwpp-tab') : null;
    if (!tab) return;
    var p = panel(); if (p) p.style.height = p.offsetHeight + 'px';
  }, true);

  document.addEventListener('click', function(e){
    var tab = e.target.closest ? e.target.closest('.sjwpp-tab') : null;
    if (!tab) return;
    if (isGold(tab)) openFlow(); else closeFlow();
  }, true);
})();
